import React, { createElement } from 'react';
import './index.css';
import { createRoot } from 'react-dom/client';
import { App } from './App';
// Set title immediately before React mounts
document.title = 'Megapack Nutrición Resuelta — Consulta Resuelta™';
// Hero image URL — MUST match the one used in App.tsx (with Cloudinary transforms)
const HERO_PRELOAD = 'https://res.cloudinary.com/dowzlbqlz/image/upload/f_auto,q_auto,w_800,c_limit/v1778382523/hf_20260509_035726_3b0b453a-cd00-4b5f-b77d-c15b35a1d726-Photoroom_1_g1m6xf.webp';
// Preconnect to critical origins
const preconnects = ['https://res.cloudinary.com', 'https://cdn.magicpatterns.com'];
preconnects.forEach(href => {
  const link = document.createElement('link');
  link.rel = 'preconnect';
  link.href = href;
  link.crossOrigin = 'anonymous';
  document.head.appendChild(link);
});
// Preload hero image for fastest LCP
const preloadImg = document.createElement('link');
preloadImg.rel = 'preload';
preloadImg.as = 'image';
preloadImg.href = HERO_PRELOAD;
(preloadImg as any).fetchPriority = 'high';
preloadImg.imageSrcset = `
  https://res.cloudinary.com/dowzlbqlz/image/upload/f_auto,q_auto,w_400,c_limit/v1778382523/hf_20260509_035726_3b0b453a-cd00-4b5f-b77d-c15b35a1d726-Photoroom_1_g1m6xf.webp 400w,
  https://res.cloudinary.com/dowzlbqlz/image/upload/f_auto,q_auto,w_600,c_limit/v1778382523/hf_20260509_035726_3b0b453a-cd00-4b5f-b77d-c15b35a1d726-Photoroom_1_g1m6xf.webp 600w,
  https://res.cloudinary.com/dowzlbqlz/image/upload/f_auto,q_auto,w_800,c_limit/v1778382523/hf_20260509_035726_3b0b453a-cd00-4b5f-b77d-c15b35a1d726-Photoroom_1_g1m6xf.webp 800w
`.trim();
preloadImg.imageSizes = '(max-width: 640px) 320px, 380px';
document.head.appendChild(preloadImg);
const container = document.getElementById('root')!;
createRoot(container).render(<App data-id="element-414" />);